import { render, staticRenderFns } from "./complianceUpload.vue?vue&type=template&id=b1082778&"
import script from "./complianceUpload.vue?vue&type=script&lang=js&"
export * from "./complianceUpload.vue?vue&type=script&lang=js&"
import style0 from "./complianceUpload.vue?vue&type=style&index=0&id=b1082778&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports